// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__32uXm","topBottomGutter":"Layout_topBottomGutter__3jD92"};